// ────────────────────────────────────────────────────────────────
// Page « Mot de passe oublié » — demande de lien de réinitialisation
// ────────────────────────────────────────────────────────────────
import { useState } from "react";
import api from "../services/api";
import "../styles/design-tokens.css";

export default function ForgotPassword({ onGoToLogin }) {
  const [email, setEmail]     = useState("");
  const [sent, setSent]       = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError]     = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await api.auth.forgotPassword(email);
      setMessage(res.message || "Si cet email est enregistré, vous recevrez un lien de réinitialisation sous peu.");
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    fontFamily: "Inter, sans-serif",
    width: "100%", padding: "10px 12px", background: "var(--ink)",
    border: "0.5px solid var(--hairline)", borderRadius: 8, color: "var(--text)",
    fontSize: 13, outline: "none", boxSizing: "border-box",
  };

  return (
    <div className="exp-public" style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: "linear-gradient(135deg, var(--ink) 0%, var(--surface) 55%, var(--surface-2) 100%)",
    }}>
      <div style={{ width: "100%", maxWidth: 400, padding: "0 16px" }}>

        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <img src="/assets/logo-icon-execpro360.png" alt="ExecPro360" style={{ width: 40, height: 40, marginBottom: 12, objectFit: "contain" }} />
          <div style={{ fontFamily: "Manrope, sans-serif", fontSize: 22, fontWeight: 800, color: "var(--text)" }}>ExecPro360</div>
        </div>

        {/* Carte */}
        <div style={{
          background: "var(--surface)", border: "0.5px solid var(--hairline)",
          borderRadius: 16, padding: "28px 24px",
        }}>
          <h2 style={{ fontFamily: "Manrope, sans-serif", fontSize: 16, fontWeight: 700, color: "var(--text)", margin: "0 0 6px" }}>
            Mot de passe oublié
          </h2>
          <p style={{ fontFamily: "Inter, sans-serif", fontSize: 12, color: "var(--text-muted)", margin: "0 0 20px" }}>
            {sent
              ? "Vérifiez votre boîte de réception."
              : "Indiquez votre email professionnel, nous vous enverrons un lien pour réinitialiser votre mot de passe."}
          </p>

          {error && (
            <div style={{
              fontFamily: "Inter, sans-serif",
              padding: "10px 12px", background: "#3b1c1c", border: "0.5px solid #e24b4a",
              borderRadius: 8, fontSize: 12, color: "#fca5a5", marginBottom: 16,
            }}>
              ⚠️ {error}
            </div>
          )}

          {sent ? (
            <div style={{
              fontFamily: "Inter, sans-serif",
              padding: "12px 14px", background: "var(--brand-tint)", border: "0.5px solid var(--brand)",
              borderRadius: 8, fontSize: 13, color: "var(--text)", lineHeight: 1.6,
            }}>
              ✅ {message}
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: 20 }}>
                <label style={{ fontFamily: "Manrope, sans-serif", fontSize: 12, color: "var(--text-muted)", display: "block", marginBottom: 6 }}>
                  Email professionnel
                </label>
                <input
                  type="email" required value={email} onChange={e => setEmail(e.target.value)}
                  placeholder="admin@masociete.fr" autoFocus
                  style={inputStyle}
                />
              </div>

              <button
                type="submit" disabled={loading}
                style={{
                  fontFamily: "Manrope, sans-serif",
                  width: "100%", padding: "11px", background: loading ? "var(--brand-hover)" : "var(--brand)",
                  border: "none", borderRadius: 8, color: "#fff",
                  fontSize: 13, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer",
                  transition: "background 0.2s",
                }}
              >
                {loading ? "Envoi en cours..." : "Envoyer le lien"}
              </button>
            </form>
          )}

          <div style={{ fontFamily: "Inter, sans-serif", textAlign: "center", marginTop: 16, fontSize: 12, color: "var(--text-muted)" }}>
            <span
              style={{ fontFamily: "Manrope, sans-serif", color: "var(--brand)", cursor: "pointer", fontWeight: 600 }}
              onClick={onGoToLogin}
            >← Retour à la connexion</span>
          </div>
        </div>
      </div>
    </div>
  );
}
